import { Grid } from "@material-ui/core"
import { CardHistoricoPedido } from "components/cards/card-historico-pedido/card-historico-pedido"
import { VendaResumidoModel } from "models/api/venda/venda-resumido-model"
import React from "react"
import { HistoricoPedidosError } from "../historico-pedidos-error/historico-pedidos-error"

export type HistoricoPedidosListDataProps = {
    list: VendaResumidoModel[]
    onClick: (id: string) => void
    carregando: boolean
}

export const HistoricoPedidoListData = ({ list, onClick, carregando }: HistoricoPedidosListDataProps) => {
    return (
        <>
            {!carregando && list.length === 0 && (
                <Grid item xs={12}>
                    <HistoricoPedidosError
                        textPrimary="Nenhum pedido encontrado."
                    />
                </Grid>
            )}
            {!carregando && list.length > 0 && list.map(venda => (
                <Grid item xs={12}>
                    <CardHistoricoPedido pedido={venda} onClick={onClick} />
                </Grid>
            ))}
        </>
    )
}